export default class HeaderProgress {
    constructor() {
        // DOM Elements
        this.header = document.getElementById('header');
        this.progressBar = this.header.querySelector('.header-progress span');

        this.ticking = false;
        this.lastKnownScrollPosition = 0;

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.updateProgress = this.updateProgress.bind(this);

        this.init();
    }

    init() {
        this.progressBar.style.transformOrigin = 'left';
        this.progressBar.style.width = '100%';

        this.calculateDimensions();

        this.addEventListeners();

        this.updateProgress(window.scrollY);
    }

    calculateDimensions() {
        this.docHeight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.clientHeight,
            document.documentElement.scrollHeight,
            document.documentElement.offsetHeight
        );
        this.windowHeight = window.innerHeight;
        this.heightDifference = this.docHeight - this.windowHeight;
    }

    addEventListeners() {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
    }

    onScroll() {
        this.lastKnownScrollPosition = window.scrollY;

        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                this.updateProgress(this.lastKnownScrollPosition);
            });
            this.ticking = true;
        }
    }

    onResize() {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                this.calculateDimensions();
                this.updateProgress(this.lastKnownScrollPosition);
                this.ticking = false;
            });
            this.ticking = true;
        }
    }

    updateProgress(scrollPos) {
        const scrollPercent = Math.min(100, Math.max(0, (scrollPos / this.heightDifference) * 100));
        this.progressBar.style.transform = `scaleX(${scrollPercent / 100})`;
        this.ticking = false;
    }

    destroy() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.progressBar.style.transform = '';
    }
}
